import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M7.463 1.543 2.877 6.13a1 1 0 0 0 0 1.414l3.587 3.587a1 1 0 0 0 1.414 0l4.587-4.586a1 1 0 0 0 0-1.415L8.878 1.543a1 1 0 0 0-1.415 0Z",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.7 7.333 1.087 8.92a2 2 0 0 0 0 2.827l.793.793a1 1 0 0 0 .707.293H4.76c.265-.001.519-.107.707-.293L6.7 11.333",
			fill: "#1890FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.7 7.333 1.087 8.92a2 2 0 0 0 0 2.827l.793.793a1 1 0 0 0 .707.293H4.76c.265-.001.519-.107.707-.293L6.7 11.333M4.167 15.5H15.5",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2016%2016%22%3E%3Cpath%20d%3D%22M7.463%201.543%202.877%206.13a1%201%200%200%200%200%201.414l3.587%203.587a1%201%200%200%200%201.414%200l4.587-4.586a1%201%200%200%200%200-1.415L8.878%201.543a1%201%200%200%200-1.415%200Z%22%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M2.7%207.333%201.087%208.92a2%202%200%200%200%200%202.827l.793.793a1%201%200%200%200%20.707.293H4.76c.265-.001.519-.107.707-.293L6.7%2011.333%22%20fill%3D%22%231890FF%22%2F%3E%3Cpath%20d%3D%22M2.7%207.333%201.087%208.92a2%202%200%200%200%200%202.827l.793.793a1%201%200%200%200%20.707.293H4.76c.265-.001.519-.107.707-.293L6.7%2011.333M4.167%2015.5H15.5%22%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";
